const ShowPasswordIcon: React.FC = () => (
    <svg width="22" height="18" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M1.03575 9.3224C0.966665 9.11513 0.966599 8.89073 1.03556 8.68343C2.42392 4.50972 6.36098 1.5 11.001 1.5C15.6389 1.5 19.5744 4.50692 20.9645 8.6776C21.0336 8.88487 21.0337 9.10927 20.9647 9.31658C19.5763 13.4903 15.6393 16.5 10.9993 16.5C6.36139 16.5 2.42583 13.4931 1.03575 9.3224Z"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M14.0002 9C14.0002 10.6569 12.6571 12 11.0002 12C9.34334 12 8.0002 10.6569 8.0002 9C8.0002 7.34315 9.34334 6 11.0002 6C12.6571 6 14.0002 7.34315 14.0002 9Z"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
)

ShowPasswordIcon.displayName = 'ShowPasswordIcon'

export default ShowPasswordIcon
